module.exports = __webpack_public_path__ + "fonts/FSSinclair-MediumItalic.e45c18b5.otf";